import { CloseRounded } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { StyledDialog } from '../../styles/StyledDialog'
import { CancelButton, SaveButton } from './index'

interface AddItemToAutocompleteModalProps<T> {
  value: T
  setValue: (values: T) => void
  open: boolean
  handleSubmit: (e: any) => void
  handleClose: () => void
}

export function AddItemToAutocompleteModal<T extends { inputName: string; name: string }>({
  value,
  setValue,
  open,
  handleSubmit,
  handleClose
}: AddItemToAutocompleteModalProps<T>) {
  const { t } = useTranslation(['global'])

  return (
    <StyledDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" aria-describedby="form-dialog-title">
      <form onSubmit={handleSubmit}>
        <DialogTitle id="form-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              {t('add')} {t(value.inputName)}
            </Typography>
            <Button onClick={handleClose} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>
        <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
          <Grid container spacing={2}>
            <Grid xs={12}>
              <DialogContentText>{t('no-content.add-your-new-item')}</DialogContentText>
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                autoFocus
                variant="filled"
                id="name"
                value={value.name}
                onChange={e => setValue({ ...value, name: e.target.value })}
                label={t(value.inputName)}
                type="text"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} color="primary">
            {t('cancel')}
          </CancelButton>
          <SaveButton type="submit" color="primary">
            {t('add')}
          </SaveButton>
        </DialogActions>
      </form>
    </StyledDialog>
  )
}
